import Vue, { VueConstructor } from 'vue'

import Modal from './Modal.vue'

import KaiPanel from './KaiPanel.vue'
import KaiButton from './KaiButton.vue'
import KaiPrimaryCtaButton from './KaiPrimaryCtaButton.vue'
import KaiSecondaryCtaButton from './KaiSecondaryCtaButton.vue'
import KaiDangerCtaButton from './KaiDangerCtaButton.vue'
import KaiSuccessCtaButton from './KaiSuccessCtaButton.vue'
import KaiForm from './KaiForm.vue'
import KaiEntityForm from './KaiEntityForm.vue'
import KaiFormField from './KaiFormField.vue'
import KaiFormInput from './KaiFormInput.vue'
import KaiFormTextArea from './KaiFormTextArea.vue'
import KaiFormSelect from './KaiFormSelect.vue'
import KaiDatePicker from './KaiDatePicker.vue'
import KaiTimeEditor from './KaiTimeEditor.vue'
import KaiCheckbox from './KaiCheckbox.vue'
import KaiCard from './KaiCard.vue'
import KaiMessage from './KaiMessage.vue'
import KaiFormErrors from './KaiFormErrors.vue'
import ApiLoader from './ApiLoader.vue'
import Busy from './Busy.vue'
import Status from './Status.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Datepicker from 'vuejs-datepicker'

export default function registration<V extends Vue>(vue: VueConstructor<V>) {
  vue.component('modal', Modal)
  vue.component('kai-panel', KaiPanel)
  vue.component('kai-button', KaiButton)
  vue.component('kai-primary-cta-button', KaiPrimaryCtaButton)
  vue.component('kai-secondary-cta-button', KaiSecondaryCtaButton)
  vue.component('kai-danger-cta-button', KaiDangerCtaButton)
  vue.component('kai-success-cta-button', KaiSuccessCtaButton)
  vue.component('kai-form', KaiForm)
  vue.component('kai-entity-form', KaiEntityForm)
  vue.component('kai-form-field', KaiFormField)
  vue.component('kai-form-input', KaiFormInput)
  vue.component('kai-form-textarea', KaiFormTextArea)
  vue.component('kai-date-picker', KaiDatePicker)
  vue.component('kai-form-select', KaiFormSelect)
  vue.component('kai-time-editor', KaiTimeEditor)
  vue.component('kai-checkbox', KaiCheckbox)
  vue.component('kai-card', KaiCard)
  vue.component('kai-message', KaiMessage)
  vue.component('kai-form-errors', KaiFormErrors)

  vue.component('api-loader', ApiLoader)
  vue.component('busy', Busy)
  vue.component('status', Status)
  Vue.component('fa-icon', FontAwesomeIcon)
  Vue.component('date-picker', Datepicker)
}
